import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogControlService {
  dialogRef: DynamicDialogRef;
  private onCloseSubject: Subject<any> = new Subject<any>();
  constructor(private readonly dialogService: DialogService) {}

  openDialog(component: any, options?: any) {
    this.onCloseSubject = new Subject<any>();  
    this.dialogRef = this.dialogService.open(component, options);
    this.dialogRef.onClose.subscribe(data => {
      this.onCloseSubject.next(data);
      this.onCloseSubject.complete();
    });
  }   

  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  onClose(): Observable<any> {
    return this.onCloseSubject.asObservable();
  }
  noNumbersValidator(event: KeyboardEvent): void {
    if (event.key >= '0' && event.key <= '9') {
      event.preventDefault(); // Prevent the numeric character from being entered
    }
  }
}
